import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class PagePattern extends Component {
  	
	render () {
															
	    return (
		    
		    <div className={'c-page__block c-page__block--pattern'}></div>
		    
		)
			
	}
}
